import React, { Component } from 'react';
import { Row, Col, Select} from 'antd';

class StatusType extends Component {
    constructor(props) {
        super(props);

        this.onChangeSelect = this.onChangeSelect.bind(this);

        this.state = {
            tempType: "",
        }
    }

    componentDidMount() {
       
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
        this.props.onchange(value)
    }

    render() {
        const Option = Select.Option
        return (
            <Select
                defaultValue={0}
                name="tempType"
                onChange={this.onChangeSelect}
                value={this.state.tempType}
            >
                <Option name="tempType" value="">Type</Option>
                <Option name="tempType" value="TEXT">Text</Option>
                <Option name="tempType" value="RICH MESSAGE">Rich</Option>
            </Select>
        );
    }
}

export default StatusType;



// WEBPACK FOOTER //
// ./src/views/Dropdown/StatusType.js